// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { DeviceMediaRequest, IDeviceMediaRequest } from "./DeviceMediaRequest.gen";

export interface ITargetMediaResponse {
	hasMediaRequest: boolean;

	deviceMediaRequest: IDeviceMediaRequest | undefined;

	clipAlreadyRequested: boolean;

	$type?: string | undefined;
}
export class TargetMediaResponse {
	constructor(data?: ITargetMediaResponse) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.deviceMediaRequest) { this.deviceMediaRequest = new DeviceMediaRequest(data.deviceMediaRequest); }
	}

	hasMediaRequest: boolean = false;

	deviceMediaRequest: DeviceMediaRequest | undefined;

	clipAlreadyRequested: boolean = false;

	static $type: string = "CoreApi.Models.MediaRequest.TargetMediaResponse, ";
	$type?: string | undefined = TargetMediaResponse.$type;
}

